export const shop = {
  navigationMenu: [
    {
      label: 'All',
      url: '/shop',
    },
    {
      label: 'Sale',
      url: '/shop/sale',
    },
    {
      title: 'Womens',
      items: [
        { label: 'Womens 1', url: '/shop/womens1' },
        { label: 'Womens 2', url: '/shop/womens2' },
        { label: 'Womens 3', url: '/shop/womens3' },
      ],
    },
    {
      title: 'Mens',
      items: [
        { label: 'Mens 1', url: '/shop/mens1' },
        { label: 'Mens 2', url: '/shop/mens2' },
        { label: 'Mens 3', url: '/shop/mens3' },
      ],
    },
    {
      title: 'Kids',
      items: [
        { label: 'Kids 1', url: '/shop/kids1' },
        { label: 'Kids 2', url: '/shop/kids2' },
        { label: 'Kids 3', url: '/shop/kids3' },
      ],
    },
    {
      title: 'Family',
      items: [
        { label: 'Family 1', url: '/shop/family1' },
        { label: 'Family 2', url: '/shop/family2' },
        { label: 'Family 3', url: '/shop/family3' },
      ],
    },
  ],
}
